import { lazy } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../../Components/Admin/ProtectedRoute';

const PaymentsLayout = lazy(() => import('./PaymentsLayout'));
const PaymentPackagesListPage = lazy(() => import('./pages/PaymentPackagesListPage'));
const PaymentPackageDetailPage = lazy(() => import('./pages/PaymentPackageDetailPage'));
const PaymentsSettings = lazy(() => import('./pages/PaymentsSettings'));
const AllPaymentsPage = lazy(() => import('./pages/AllPaymentsPage'));
const PaymentBankFormatRulesSettings = lazy(() => import('./pages/PaymentBankFormatRulesSettings'));

const PaymentsRouters = (
  <Route
    path="/payments"
    element={
      <ProtectedRoute minRole="USER" appSlug="payments">
        <PaymentsLayout />
      </ProtectedRoute>
    }
  >
    <Route index element={<PaymentPackagesListPage />} />
    <Route path="all" element={<AllPaymentsPage />} />
    <Route path="all/:id" element={<PaymentPackageDetailPage />} />
    <Route path="settings/permissions" element={<PaymentsSettings />} />
    <Route path="settings/bank-format-rules" element={<PaymentBankFormatRulesSettings />} />
    <Route path=":id" element={<PaymentPackageDetailPage />} />
  </Route>
);

export default PaymentsRouters;
